import React from "react";
import "./App.css";
import { CssBaseline, ThemeProvider } from "@mui/material";
import Router from "./router";
import { useSelector } from "src/store/Store";
import { ThemeSettings } from "./theme/Theme";
import { AppState } from "./store/Store";
import RTL from "./layouts/customizer/RTL";
import { useRoutes } from "react-router-dom";
import { QueryClient, QueryClientProvider, QueryCache } from "react-query";
import axios from "axios";
import NiceModal from "@ebay/nice-modal-react";
import AuthBoundary from "./AuthBoundary";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (axios.isAxiosError(error)) {
          if (error.response?.status.toString()[0] === "4") {
            return false;
          }
        }
        if (failureCount === 2) {
          return false;
        }
        return true;
      }
    }
  },
  queryCache: new QueryCache({})
});

export default function App() {
  const routing = useRoutes(Router);
  const theme = ThemeSettings();
  const customizer = useSelector((state: AppState) => state.customizer);
  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <RTL direction={customizer.activeDir}>
          <NiceModal.Provider>
            <CssBaseline />
            <AuthBoundary />
            {routing}
          </NiceModal.Provider>
        </RTL>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
